import { AppUI, ExerciseUI } from '@seedlang/state';
import { isPresent } from '@seedlang/utils';
import WorksheetTab from 'components/worksheet/tab';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

@observer
class WorksheetTabs extends React.Component {
  static defaultProps = {
    showCustomTabs: true,
  };

  @computed get showExercisesTab() {
    return ExerciseUI.hasWorksheet && ExerciseUI.worksheet?.exercises.length > 0;
  }

  @computed get showVocabTab() {
    return ExerciseUI.worksheet?.hasPublishedVocab;
  }

  @computed get showCustomTabs() {
    return this.props.showCustomTabs && ExerciseUI.hasWorksheet && isPresent(ExerciseUI.worksheet.customTabs);
  }

  @computed get showDownloadsTab() {
    return (this.props.alwaysShowDownloads || (ExerciseUI.worksheet?.downloadLinks?.length > 0));
  }

  @computed get showDiscussTab() {
    return ExerciseUI.site.showWorksheetComments && (ExerciseUI.worksheet?.hasForumThread || this.props.alwaysShowDiscuss);
  }

  @computed get tabCount() {
    let res = 0;
    if (this.showVocabTab) {
      res += 1;
    }
    if (this.showExercisesTab) {
      res += 1;
    }
    if (this.showCustomTabs) {
      res += ExerciseUI.worksheet.customTabs.length;
    }
    if (this.showDownloadsTab) {
      res += 1;
    }
    if (this.showDiscussTab) {
      res += 1;
    }
    return res;
  }

  @computed get minTabWidth() {
    if (AppUI.layout.viewportWidth <= 420) {
      if (this.tabCount === 2 || this.tabCount === 4) {
        return '40%';
      } return '30%';
    } return null;
  }

  render() {
    const { worksheetId, params } = this.props;

    return (
      <>
        {
          this.showExercisesTab &&
            <WorksheetTab
              small={this.props.small}
              worksheetId={worksheetId}
              params={params}
              buttonText='exercises'
              routeName={`${ExerciseUI.worksheetNamespace}.exercises.show`}
              iconName='lightbulb-o'
              minWidth={this.minTabWidth}
              activeColor={this.props.activeColor}
              activeBackground={this.props.activeBackground}
            />
        }
        {
          this.showVocabTab &&
            <WorksheetTab
              small={this.props.small}
              worksheetId={worksheetId}
              params={params}
              buttonText='vocab'
              routeName={`${ExerciseUI.worksheetNamespace}.vocab.show`}
              iconName='list'
              minWidth={this.minTabWidth}
              activeColor={this.props.activeColor}
              activeBackground={this.props.activeBackground}
            />
        }
        {
          this.showCustomTabs && ExerciseUI.worksheet.customTabs.map(item =>
            {
              return (
                <WorksheetTab
                  key={item.id}
                  worksheetId={worksheetId}
                  small={this.props.small}
                  customTabId={item.id}
                  params={params}
                  buttonText={item.title}
                  routeName={`${ExerciseUI.worksheetNamespace}.custom_tab.show`}
                  iconName={item.icon}
                  minWidth={this.minTabWidth}
                  activeColor={this.props.activeColor}
                  activeBackground={this.props.activeBackground}
                />
              );
            },
          )
        }
        {
          this.showDownloadsTab &&
            <WorksheetTab
              small={this.props.small}
              worksheetId={worksheetId}
              params={params}
              buttonText='downloads'
              routeName={`${ExerciseUI.worksheetNamespace}.download_links.index`}
              iconName='download'
              minWidth={this.minTabWidth}
            />
        }
        {
          this.showDiscussTab &&
            <WorksheetTab
              small={this.props.small}
              worksheetId={worksheetId}
              params={params}
              buttonText='discuss'
              routeName={`${ExerciseUI.worksheetNamespace}.comments.show`}
              iconName='ChatOutline'
              minWidth={this.minTabWidth}
            />
        }
      </>
    );
  }
}

export default WorksheetTabs;